/**
 * Chocoodad — Global JavaScript
 * Handles: cart AJAX, lazy loading, scroll effects, form helpers
 */

// Money formatter
Chocoodad.formatMoney = function(cents, format) {
  if (!format) format = Chocoodad.money_format;
  const amount = (cents / 100).toFixed(2);
  return format.replace(/\{\{\s*amount\s*\}\}/, amount)
               .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
};

// Add to Cart (AJAX)
Chocoodad.addToCart = async function(formData) {
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    });
    if (!res.ok) throw new Error('Add to cart failed');
    const item = await res.json();

    // Update cart count
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();
    document.querySelectorAll('.cart-count-bubble').forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });

    // Open drawer
    if (Chocoodad.cartType === 'drawer') {
      Chocoodad.openDrawer('CartDrawer');
    } else {
      window.location.href = '/cart';
    }

    return item;
  } catch(err) {
    console.error('addToCart error:', err);
    throw err;
  }
};

// Sticky ATC on product page
(function initStickyAtc() {
  const stickyBar = document.querySelector('.sticky-atc');
  const atcBtn = document.querySelector('.product-info__atc');
  if (!stickyBar || !atcBtn) return;

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
    });
  }, { threshold: 0 });

  observer.observe(atcBtn);
})();

// Carousel / scroll-snap dots
document.querySelectorAll('[data-carousel]').forEach(carousel => {
  const slides = carousel.querySelectorAll('[data-slide]');
  const dots = carousel.parentElement && carousel.parentElement.querySelectorAll('[data-dot]');
  if (!slides.length || !dots || !dots.length) return;

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const idx = Array.from(slides).indexOf(entry.target);
        dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
      }
    });
  }, { root: carousel, threshold: 0.5 });

  slides.forEach(s => observer.observe(s));
});

// Native lazy loading fallback
if ('loading' in HTMLImageElement.prototype) {
  // browser supports native lazy loading
} else {
  // Simple polyfill: observe and set src
  const lazyImages = document.querySelectorAll('img[loading="lazy"]');
  const imgObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        if (img.dataset.src) img.src = img.dataset.src;
        imgObserver.unobserve(img);
      }
    });
  });
  lazyImages.forEach(img => imgObserver.observe(img));
}

// Accordion (FAQ)
document.querySelectorAll('[data-accordion-trigger]').forEach(trigger => {
  trigger.addEventListener('click', function() {
    const expanded = this.getAttribute('aria-expanded') === 'true';
    this.setAttribute('aria-expanded', !expanded);
    const panel = document.getElementById(this.getAttribute('aria-controls'));
    if (panel) {
      panel.hidden = expanded;
    }
  });
});

// Product card image slider (arrows + dots; touch swipes the track natively)
Chocoodad.initCardSliders = function(scope) {
  (scope || document).querySelectorAll('[data-card-slider]').forEach(function(media) {
    if (media.dataset.sliderReady) return;
    media.dataset.sliderReady = '1';
    var track = media.querySelector('.product-card__track');
    var slides = media.querySelectorAll('.product-card__slide');
    var dots = media.querySelectorAll('.product-card__dot');
    var prev = media.querySelector('.product-card__nav--prev');
    var next = media.querySelector('.product-card__nav--next');
    if (!track || slides.length < 2) return;
    var current = 0;
    function go(i) {
      current = Math.max(0, Math.min(slides.length - 1, i));
      // Scroll the card's own track directly. scrollIntoView() would also scroll
      // any ancestor horizontal scroller (e.g. the homepage collection-feature rail),
      // which made the arrows appear to "not work" inside that section.
      track.scrollTo({ left: slides[current].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    function sync() {
      dots.forEach(function(d, di){ d.classList.toggle('is-active', di === current); });
      if (prev) prev.disabled = current <= 0;
      if (next) next.disabled = current >= slides.length - 1;
    }
    if (prev) prev.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); go(current - 1); });
    if (next) next.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); go(current + 1); });
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { current = Array.prototype.indexOf.call(slides, e.target); sync(); }
      });
    }, { root: track, threshold: 0.6 });
    slides.forEach(function(s){ io.observe(s); });
    sync();
  });
};
Chocoodad.initCardSliders();

// Photo upload preview
document.querySelectorAll('[data-photo-input]').forEach(input => {
  input.addEventListener('change', function() {
    const preview = document.querySelector('[data-photo-preview]');
    if (!preview || !this.files[0]) return;
    const url = URL.createObjectURL(this.files[0]);
    preview.src = url;
    preview.style.display = 'block';
  });
});
